import React from 'react';
import theme from 'shared/constants/theme.json';

export default () => {
  const textSecondary = theme['text-color-secondary'];
  const borderColor = theme['border-color-base'];
  const primaryColor = theme['primary-color'];

  return (
    <svg width="230" height="280" viewBox="0 0 230 280" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="229" height="279" fill="white" />
      <path d="M48 30H184.407M85.8355 46.5854H145.576" stroke={textSecondary} strokeWidth="3" />
      <path d="M22.1059 169.024H56.9544V167.073H22.1059V169.024Z" fill={textSecondary} />
      <path d="M60.9371 176.829H16.1319V175.854H60.9371V176.829Z" fill={textSecondary} />
      <path d="M55.9587 188.537H16.1319V187.561H55.9587V188.537Z" fill={textSecondary} />
      <path d="M16.1319 200.244H60.9371V199.268H16.1319V200.244Z" fill={textSecondary} />
      <path d="M60.9371 211.951H16.1319V210.976H60.9371V211.951Z" fill={textSecondary} />
      <path d="M16.1319 180.732H50.9804V179.756H16.1319V180.732Z" fill={textSecondary} />
      <path d="M50.9804 192.439H16.1319V191.463H50.9804V192.439Z" fill={textSecondary} />
      <path d="M16.1319 204.146H50.9804V203.171H16.1319V204.146Z" fill={textSecondary} />
      <path d="M50.9804 215.854H16.1319V214.878H50.9804V215.854Z" fill={textSecondary} />
      <path d="M16.1319 184.634H60.9371V183.659H16.1319V184.634Z" fill={textSecondary} />
      <path d="M55.9587 196.341H16.1319V195.366H55.9587V196.341Z" fill={textSecondary} />
      <path d="M16.1319 208.049H55.9587V207.073H16.1319V208.049Z" fill={textSecondary} />
      <path d="M60.9371 219.756H16.1319V218.78H60.9371V219.756Z" fill={textSecondary} />
      <path d="M99.7683 169.024H134.617V167.073H99.7683V169.024Z" fill={textSecondary} />
      <path d="M138.599 176.829H93.7943V175.854H138.599V176.829Z" fill={textSecondary} />
      <path d="M133.621 188.537H93.7943V187.561H133.621V188.537Z" fill={textSecondary} />
      <path d="M93.7943 200.244H138.599V199.268H93.7943V200.244Z" fill={textSecondary} />
      <path d="M138.599 211.951H93.7943V210.976H138.599V211.951Z" fill={textSecondary} />
      <path d="M93.7943 180.732H128.643V179.756H93.7943V180.732Z" fill={textSecondary} />
      <path d="M128.643 192.439H93.7943V191.463H128.643V192.439Z" fill={textSecondary} />
      <path d="M93.7943 204.146H128.643V203.171H93.7943V204.146Z" fill={textSecondary} />
      <path d="M128.643 215.854H93.7943V214.878H128.643V215.854Z" fill={textSecondary} />
      <path d="M93.7943 184.634H138.599V183.659H93.7943V184.634Z" fill={textSecondary} />
      <path d="M133.621 196.341H93.7943V195.366H133.621V196.341Z" fill={textSecondary} />
      <path d="M93.7943 208.049H133.621V207.073H93.7943V208.049Z" fill={textSecondary} />
      <path d="M138.599 219.756H93.7943V218.78H138.599V219.756Z" fill={textSecondary} />
      <rect x="176" y="226" width="36" height="10" rx="1" fill={textSecondary} />
      <path d="M177.431 169.024H212.279V167.073H177.431V169.024Z" fill={textSecondary} />
      <path d="M216.262 176.829H171.457V175.854H216.262V176.829Z" fill={textSecondary} />
      <path d="M211.283 188.537H171.457V187.561H211.283V188.537Z" fill={textSecondary} />
      <path d="M171.457 200.244H216.262V199.268H171.457V200.244Z" fill={textSecondary} />
      <path d="M216.262 211.951H171.457V210.976H216.262V211.951Z" fill={textSecondary} />
      <path d="M171.457 180.732H206.305V179.756H171.457V180.732Z" fill={textSecondary} />
      <path d="M206.305 192.439H171.457V191.463H206.305V192.439Z" fill={textSecondary} />
      <path d="M171.457 204.146H206.305V203.171H171.457V204.146Z" fill={textSecondary} />
      <path d="M206.305 215.854H171.457V214.878H206.305V215.854Z" fill={textSecondary} />
      <path d="M171.457 184.634H216.262V183.659H171.457V184.634Z" fill={textSecondary} />
      <path d="M211.283 196.341H171.457V195.366H211.283V196.341Z" fill={textSecondary} />
      <path d="M171.457 208.049H211.283V207.073H171.457V208.049Z" fill={textSecondary} />
      <path d="M216.262 219.756H171.457V218.78H216.262V219.756Z" fill={textSecondary} />
      <rect x="21" y="226" width="36" height="10" rx="1" fill={textSecondary} />
      <rect x="98" y="226" width="36" height="10" rx="1" fill={textSecondary} />
      <path d="M13.6492 150.782V74.1657L115.423 112.712L13.6492 150.782ZM14.5197 151.524L116.841 113.249L217.9 151.524H14.5197ZM218.753 150.778L118.262 112.718L218.753 75.1271V150.778ZM218.753 74.0594L116.843 112.181L14.7148 73.5H218.753V74.0594Z" stroke={textSecondary} />
      <circle cx="117" cy="77" r="23" fill="white" stroke={primaryColor} strokeWidth="4" />
      <line x1="116" y1="61" x2="116" y2="81" stroke={primaryColor} strokeWidth="4" />
      <line x1="115" y1="79.2679" x2="125.392" y2="85.268" stroke={primaryColor} strokeWidth="4" />
      <rect x="0.5" y="0.5" width="229" height="279" stroke={borderColor} />
    </svg>
  );
};
